import { Component, Input } from '@angular/core';

@Component({
  selector: 'eci-details-popup',
  templateUrl: './details-popup.component.html',
  styleUrls: ['./details-popup.component.scss']
})
export class DetailsPopupComponent {
  
  @Input() data: any;
  @Input() isB2BSaleOrder: boolean = false;

  constructor(

  ) { }

}
